import React, { PropTypes } from 'react';
import Item from 'common/components/entry_gallery/item';

const ImageNameGrid = ({ items, itemVariation, ...otherProps }) => {
  return (
    <div className="row small-up-1 medium-up-2 large-up-3 project-entries-gallery grid">
      { items.map((item, i) => (
      <Item key={i} item={item} variation={itemVariation} {...otherProps} />
      )) }
    </div>
  );
}

ImageNameGrid.propTypes = {
  items: PropTypes.array.isRequired,
  itemVariation: PropTypes.string.isRequired,
};

export default ImageNameGrid;



// WEBPACK FOOTER //
// ./common/components/entry_gallery/image_name_grid.jsx